export default (theme) => ({
  cardContainer: {
    width: "100%",
    borderRadius: "5px",
    position: "relative",
    paddingRight: 60,
  },
  imageTextContainer: {
    display: "flex",
    justifyContent: "flex-start",
  },
  iconContainer: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    background: "#fff",
    padding: "0 10px",
  },
  titleStyle: {
    fontSize: 16,
    color: "#323232",
    fontWeight: 600,
  },
  subtitleStyle: {
    fontSize: 14,
    color: "#323232",
    fontWeight: 600,
  },
  iconComponenticonComponent: {
    cursor: "pointer",
  },
});
